/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Submitted_NoteInputs */



/**
* | output |
* | --- |
* | "Decklist received. You can replace it until the tournament starts." |
*
* @param {Decks_Submitted_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_submitted_note = /** @type {((inputs?: Decks_Submitted_NoteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Submitted_NoteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decklist reçue. Vous pouvez la remplacer jusqu'au début du tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Decklist recibida. Puede reemplazarla hasta que empiece el torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Decklist recebida. Você pode substituí-la até o torneio começar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Decklist ricevuta. Puoi sostituirla fino all'inizio del torneo.")
	return /** @type {LocalizedString} */ ("Decklist received. You can replace it until the tournament starts.")
});